"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoaderRadar = exports.Loader = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _loader = _interopRequireDefault(require("./loader.gif"));
require("./style.sass");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Loader = function Loader(props) {
  var mainClassName = (0, _classnames.default)('sber-loader', props.className);
  return /*#__PURE__*/_react.default.createElement("img", _extends({}, props, {
    className: mainClassName,
    src: _loader.default,
    alt: ""
  }));
};
exports.Loader = Loader;
Loader.propTypes = {
  className: _propTypes.default.string,
  styles: _propTypes.default.any
};
var LoaderRadar = function LoaderRadar(props) {
  var mainClassName = (0, _classnames.default)('sber-loader-radar', props.className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
    className: mainClassName
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sber-loader-radar__left"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sber-loader-radar__right"
  }));
};
exports.LoaderRadar = LoaderRadar;
LoaderRadar.propTypes = {
  className: _propTypes.default.string,
  styles: _propTypes.default.any
};